import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=2259e1b1&"
import script from "./AgentList.vue?vue&type=script&lang=js&"
export * from "./AgentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports